/** Product name shown in sidebar header (no logo). */
export const PRODUCT_DISPLAY_NAME = 'NextFollowUp';
